import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import './DropdownMenu.scss';

import { ReactComponent as MoreButton } from '../../assets/images/svg/moreButton.svg';
import { checkActivePath } from '../../helpers/utils';

const DropdownMenu = ({ items = [], extraItems = [] }) => {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const [isShow, setIsShow] = useState(false);
  const handleMouseEnter = () => {
    setIsShow(true);
  };

  const handleMouseLeave = () => {
    setIsShow(false);
  };
  return (
    <div className="dropdown-menu" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <button className="dropdown-menu__btn">
        <MoreButton />
      </button>
      <ul
        className={classNames('dropdown-menu__links-container', {
          visible: isShow
        })}
      >
        {items.map((i) => (
          <li key={i.id}>
            <NavLink className="dropdown-menu__link" to={`/tv-content/${i.id}`}>
              {i.title_localized[lang]}
            </NavLink>
          </li>
        ))}
        {extraItems.map((i) => (
          <li key={i.path}>
            <NavLink
              className={classNames('dropdown-menu__link', {
                active: checkActivePath(i.activePathNames, location.pathname)
              })}
              to={i.path}
            >
              {i.title}
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DropdownMenu;

DropdownMenu.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      title_localized: PropTypes.shape({ ua: PropTypes.string, ru: PropTypes.string })
    })
  ),
  extraItems: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string,
      title: PropTypes.string,
      activePathNames: PropTypes.arrayOf(PropTypes.string)
    })
  )
};
